export const readAsBinaryStringAsync = (file: File | Blob): Promise<string | ArrayBuffer | null> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader()

        reader.onload = () => {
            resolve(reader.result)
        }

        reader.onerror = (e) => {
            reject(e)
        }

        reader.readAsBinaryString(file);
    })
